import React from 'react';

import { processTextWithLinks } from '../../utilities/processTextWithLinks';
import styles from './checkbox-input.module.css';

/**
 * CheckboxInput component displays a checkbox input with a label.
 *
 * @param {Object} props - The component props
 * @param {string} props.id - The input id
 * @param {string} props.name - The input name
 * @param {boolean} props.required - Whether the input is required
 * @param {string} props.labelText - The label text
 * @param {boolean} props.checked - Whether the checkbox is checked
 * @param {function} props.onChange - Callback when checkbox state changes
 * @returns {import('react').JSX.Element} The rendered component
 */
export const CheckboxInput = ({ id, name, required = false, labelText, checked = false, onChange }) => {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.checked);
    }
  };

  return (
    <div className={styles['checkbox-input']}>
      <input
        className={styles['checkbox-input__input']}
        id={id}
        name={name}
        type="checkbox"
        required={required}
        checked={checked}
        onChange={handleChange}
      />
      <label className={styles['checkbox-input__label']} htmlFor={id}>
        <p>{processTextWithLinks(labelText)}</p>
      </label>
    </div>
  );
};
